import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1),
    },
    pageContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      height: '100vh',
      paddingBottom: '10vh',
    },
    siteTitle: {
      fontFamily: 'lato-hairline',
      paddingBottom: '10vh',
    },
  }),
);

export default useStyles;
